import { Group, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { alphaNumericRegex, descriptionRegex } from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";

export const AddInterest = ({
  opened,
  setOpened,
  setUpdate,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      interestName: "",
      interestDescription: "",
    },

    validate: {
      interestName: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Alphabetic Name with 2 or more characters",
      interestDescription: (value) =>
        value?.trim()?.length > 20 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
    },
  });

  //fetch data for edit and set in form
  useEffect(() => {
    if (editModalState) {
      form.setFieldValue("interestName", editData.interestName);
      form.setFieldValue("interestDescription", editData.interestDescription);
    }
  }, [opened, editModalState]);

  const onSubmit = (values) => {
    let url = "";
    if (editModalState) {
      values.interestId = editData._id;
      url = "interest/editInterest";
      setEditData({});
      setEditModalState(false);
    } else {
      url = "interest/addInterest";
    }
    form.reset();
    setLoading(true);

    addAndEditData(values, setOpened, setUpdate, url);
  };
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        Interest Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter Interest Name"
        form={form}
        validateName="interestName"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Text mt="md" mb={0} weight={500}>
        Description
      </Text>
      <DescriptionField
        maxRows={4}
        minRows={3}
        autosize={true}
        width="100%"
        placeholder="Enter Interest Description"
        form={form}
        validateName="interestDescription"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Update" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );
  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      setEditData={setEditData}
      setEditModalState={setEditModalState}
      InternalComponent={InternalContent}
      title="Add Interest"
      form={form}
      addEdit={true}
    />
  );
};
